import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=03ece1ea&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"
import style0 from "./DataList.vue?vue&type=style&index=0&id=03ece1ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports